import * as React from "react"
import { Modal, Button, Container, Col, Row, Form } from "react-bootstrap"
import { Supervisor } from "../../../api/OrderResults/OrderResultModel/GeneralInformation"
import PhoneNumberMaskedInput from "../../FormattedInputs/PhoneNumberMaskedInput"
import { PhoneRegexp } from "../../../config/Constants"

interface SupervisorsModalProps {
  Supervisor1: Supervisor
  Supervisor2: Supervisor
  onSave: (supervisors: Supervisor[]) => void
  onClose: () => void
}

interface  SupervisorsModalState {
  Supervisor1FirstName: string
  Supervisor1LastName: string
  Supervisor1ContactPhone: string
  Supervisor2FirstName: string
  Supervisor2LastName: string
  Supervisor2ContactPhone: string
}

export default class EmployeeRegModeModal extends React.Component<SupervisorsModalProps, SupervisorsModalState> {
  state: SupervisorsModalState = {
    Supervisor1FirstName: this.props.Supervisor1.FirstName,
    Supervisor1LastName: this.props.Supervisor1.LastName,
    Supervisor1ContactPhone: this.props.Supervisor1.ContactPhone,
    Supervisor2FirstName: this.props.Supervisor2.FirstName,
    Supervisor2LastName: this.props.Supervisor2.LastName,
    Supervisor2ContactPhone: this.props.Supervisor2.ContactPhone,
  }

  isPhoneValid = (value: string) => !!value.length && (value.replace(/\D/g, "").length === 10 || PhoneRegexp.test(value))

  handleClose = () => this.props.onClose()

  handleSave = () => {
    const SuperVisor1 = {FirstName: this.state.Supervisor1FirstName, LastName: this.state.Supervisor1LastName, ContactPhone: this.state.Supervisor1ContactPhone }
    const SuperVisor2 = {FirstName: this.state.Supervisor2FirstName, LastName: this.state.Supervisor2LastName, ContactPhone: this.state.Supervisor2ContactPhone }
    this.props.onSave([SuperVisor1, SuperVisor2])
  }

  render() {
    const { Supervisor1FirstName, Supervisor1LastName, Supervisor1ContactPhone, Supervisor2FirstName, Supervisor2LastName, Supervisor2ContactPhone } = this.state

    const requiredSup1Data = !!Supervisor1FirstName.length || !!Supervisor1LastName.length || !!Supervisor1ContactPhone.length
    const requiredSup2Data = !!Supervisor2FirstName.length || !!Supervisor2LastName.length || !!Supervisor2ContactPhone.length
    const validContactPhone1 = this.isPhoneValid(Supervisor1ContactPhone) || !requiredSup1Data
    const validContactPhone2 = this.isPhoneValid(Supervisor2ContactPhone) || !requiredSup2Data
    const validSup1FirstName = !!Supervisor1FirstName.length || !requiredSup1Data
    const validSup1LastName =  !!Supervisor1LastName.length || !requiredSup1Data
    const validSup2FirstName = !!Supervisor2FirstName.length || !requiredSup2Data
    const validSup2LastName =  !!Supervisor2LastName.length || !requiredSup2Data

    return <Modal backdrop="static" size="xl" centered show onHide={this.handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>Supervisors</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Container fluid>
        <Row className="form-group">
          <Form.Label column lg={4} htmlFor="supervisor1FirstName">Supervisor 1 First\Last Names</Form.Label>
          <Col lg={4}>
            <Form.Control id="contactFirstName" type="text"
              autoComplete="new-password"
              value={Supervisor1FirstName}
              onChange={e => this.setState({ Supervisor1FirstName: e.target.value })}
              isInvalid={!validSup1FirstName} />
          </Col>
          <Col lg={4}>
            <Form.Control id="supervisor1LastName" type="text"
              autoComplete="new-password"
              value={Supervisor1LastName}
              onChange={e => this.setState({ Supervisor1LastName: e.target.value })}
              isInvalid={!validSup1LastName} />
          </Col>
        </Row>
        <Row className="form-group">
          <Form.Label column lg={4} htmlFor="contactPhone1">Supervisor 1 Contact Phone #</Form.Label>
          <Col lg={4}>
            <PhoneNumberMaskedInput
              autoComplete="new-password"
              value={Supervisor1ContactPhone}
              onChange={(value: string) => this.setState({ Supervisor1ContactPhone: value })}
              isInvalid={!validContactPhone1} />
          </Col>
        </Row>
        <Row className="form-group">
          <Form.Label column lg={4} htmlFor="supervisor2FirstName">Supervisor 2 First\Last Names</Form.Label>
          <Col lg={4}>
            <Form.Control id="contactFirstName" type="text"
              autoComplete="new-password"
              value={Supervisor2FirstName}
              onChange={e => this.setState({ Supervisor2FirstName: e.target.value })}
              isInvalid={!validSup2FirstName} />
          </Col>
          <Col lg={4}>
            <Form.Control id="supervisor2LastName" type="text"
              autoComplete="new-password"
              value={Supervisor2LastName}
              onChange={e => this.setState({ Supervisor2LastName: e.target.value })}
              isInvalid={!validSup2LastName} />
          </Col>
        </Row>
        <Row className="form-group">
          <Form.Label column lg={4} htmlFor="contactPhone2">Supervisor 2 Contact Phone #</Form.Label>
          <Col lg={4}>
            <PhoneNumberMaskedInput
              autoComplete="new-password"
              value={Supervisor2ContactPhone}
              onChange={(value: string) => this.setState({ Supervisor2ContactPhone: value })}
              isInvalid={!validContactPhone2} />
          </Col>
        </Row>
      </Container>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={this.handleClose}>CANCEL</Button>
      <Button variant="primary" onClick={() => this.handleSave()}>APPLY</Button>
    </Modal.Footer>
  </Modal >
  }
}